import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@mui/material";

import { ProductionGroupsConfigurationModal } from "../production-groups-configuration-modal";

export const ProductionGroupNewButton: React.FC = () => {
	const [showNew, setShowNew] = React.useState(false);

	return (
		<>
			<ProductionGroupsConfigurationModal open={showNew} onClose={() => setShowNew(false)} />
			<Button
				variant="contained"
				onClick={() => setShowNew(true)}
				data-testid="production-group-new-button__button__open-modal"
				data-pendoid="production-groups__button__new"
			>
				<FormattedMessage id="New Production Group" defaultMessage="New Production Group" />
			</Button>
		</>
	);
};
